import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import UsersIndex from '@/views/users/index.vue'
import CreateUserAccount from '@/views/users/user-details/create-user-account.vue'
import UserDetails from '@/views/users/user-details/index.vue'
import UserAccounts from '@/views/users/user-details/user-accounts.vue'
import UserDiscounts from '@/views/users/user-details/user-discounts.vue'
import UserInvitees from '@/views/users/user-details/user-invitees.vue'
import UserTransactions from '@/views/users/user-details/user-transactions.vue'

const usersRoutes: RouteRecordRaw[] = [
  {
    path: '/users',
    meta: { layout: DefaultLayout, middleware: ['auth'] },
    children: [
      { path: '', name: 'Users', component: UsersIndex },
      { path: ':id', name: 'User-Details', component: UserDetails, props: true },
      { path: ':id/discounts', name: 'User-Discounts', component: UserDiscounts, props: true },
      { path: ':id/accounts', name: 'User-Accounts', component: UserAccounts, props: true },
      { path: ':id/accounts/create', name: 'Create-User-Account', component: CreateUserAccount, props: true },
      { path: ':id/transactions', name: 'User-Transactions', component: UserTransactions, props: true },
      { path: ':id/invited-users', name: 'User-Invitees', component: UserInvitees, props: true },
    ],
  },
]

export default usersRoutes
